import { MAP_MODES } from './constants.js';

/**
 * Base state container shared by all map mixins.
 * Holds references to Leaflet layers, UI panels, and runtime caches.
 */
export class MapState {
	constructor() {
		this.map = null;
		this.countryMarkers = [];
		this.cityMarkers = [];
		this.countryLayer = globalThis.L ? globalThis.L.layerGroup() : null;
		this.cityLayer = globalThis.L ? globalThis.L.layerGroup() : null;
		this.countryMarkerPane = 'countryMarkers';
		this.cityCompactMarkerIcon = null;
		this.cityMarkersCompactMode = false;
		this.starLineLayer = null;
		this.starLineSegments = [];
		this.infoPanelShell = null;
		this.infoPanel = null;
		this.lorePanelEl = null;
		this.infoToggleButton = null;
		this.searchPanelEl = null;
		this.searchInputEl = null;
		this.searchResultsEl = null;
		this.tabButtons = [];
		this.activePanel = 'lore';
		this.searchEntries = [];
		this.infoCache = {};
		this.boundaryCache = {};
		this.markedLoader = null;
		this.boundaryLayer = null;
		this.boundaryHaloLayer = null;
		this.boundaryCoreLayer = null;
		this.boundaryControlLayer = null;
		this.boundaryRequestId = 0;
		this.activeBoundarySlug = null;
		this.boundaryEditState = null;
		this.boundaryHandleIcon = null;
		this.countryEntryMap = typeof WeakMap === 'function' ? new WeakMap() : null;
		this.cityEntryMap = typeof WeakMap === 'function' ? new WeakMap() : null;
		this.highlightedState = null;
		this.markedLoader = null;
		this.panelRevealScheduled = false;
		this.cityMarkerLoader = null;
		this.cityMarkerIcon = null;
		this.suppressAnchorUpdate = false;
		this.isInternalAnchorUpdate = false;
		this.lastAnchorValue = null;
		this.lastLoreSelection = null;
		this.lastDebugSelection = null;
		this.baseTileLayer = null;
		this.starModeActive = false;
		this.boundaryLayerWasVisible = false;
		this.boundaryHandlesWereVisible = false;
		this.starModeControl = null;
		this.starModeButton = null;
		this.starModeStatusEl = null;
		this.starModeContainer = null;
		this.starModeControlRevealed = true;
		this.starMappingData = null;
		this.constellationLineDefs = null;
		this.starDataLoaded = false;
		this.pendingStarDataLoad = false;
		this.starDataPromise = null;
		this.starLinePane = 'starLines';
		this.syntheticStarPane = 'syntheticCities';
		this.starDotModeCompact = false;
		this.starLinesByCity = new Map();
		this.cityCoordinateIndex = new Map();
		this.baseTileOpacity = 1;
		this.previousTileOpacity = null;
		this.activeMode = MAP_MODES.NORMAL;
		this.defaultZoomLevel = 3;
	}
}
